/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable import/no-cycle */
/* eslint-disable react/default-props-match-prop-types */
import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import Tippy from '@tippy.js/react';
import { Icon, Text } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
export interface ToolTipProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  hint: React.ReactNode;
  placement?: 'top' | 'bottom' | 'right' | 'left' | 'bottom-end';
  asWrapper?: boolean;
  noIcon?: boolean;
  /** Включает/выключает интерактивность всплывающего тултипа */
  interactive?: boolean;
  /** Уcтанавливает z-index на корневом узле тултипа */
  zIndex?: number;
  /** Bg color контейнера тултипа */
  theme?: string;
  /** Переключает вид иконки на квадратную с i */
  squareIcon?: boolean;
  activeCountrySteam?: string;
  visible?: boolean;
  onHidden?: () => void;
  maxWidth?: string;
  isActive?: boolean;
}
const ToolTipText: FC<ToolTipProps> = ({
  children,
  hint,
  placement,
  noIcon,
  asWrapper,
  interactive,
  zIndex,
  theme,
  squareIcon,
  activeCountrySteam,
  visible,
  onHidden,
  maxWidth,
  isActive,
  ...rest
}) => {
  const tippyContent = <HintTextWrapper size="md">{hint}</HintTextWrapper>;
  const isAsWrapper = !!asWrapper;
  return <ToolTipWrapper {...rest} data-testid="tooltip">
      {!isAsWrapper && children && <StyledText>{children}</StyledText>}
      <StyledTippy arrow interactive={interactive} maxWidth={maxWidth} placement={placement} content={tippyContent} zIndex={zIndex} theme={theme} visible={visible} onHidden={onHidden} className="custom-tippy-text">
        <InnerWrapper asWrapper={asWrapper as boolean} isActive={isActive as boolean}>
          {isAsWrapper ? <Wrapper noIcon={noIcon}>{children}</Wrapper> : false}
          {!noIcon && <StyledIcon withWrapper icon={squareIcon ? 'icon-24/SuperInfoGrey' : 'baseX16/question-circle'} activeCountrySteam={activeCountrySteam} />}
        </InnerWrapper>
      </StyledTippy>
    </ToolTipWrapper>;
};
ToolTipText.defaultProps = {
  placement: 'top',
  interactive: true,
  zIndex: 9999,
  theme: '#000000',
  maxWidth: '250px'
};
export default ToolTipText;
const ToolTipWrapper = /*#__PURE__*/styled('div')({
  name: "ToolTipWrapper",
  class: "t11e1zlw",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => Text;
const _exp2 = /*#__PURE__*/() => ({
  noIcon
}) => noIcon ? 0 : '4px';
const StyledText = /*#__PURE__*/styled(_exp())({
  name: "StyledText",
  class: "sv1lj99",
  propsAsIs: true,
  vars: {
    "sv1lj99-0": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => ({
  noIcon
}) => noIcon ? 0 : '4px';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w175x0cp",
  propsAsIs: false,
  vars: {
    "w175x0cp-0": [_exp3()]
  }
});
interface StyleIconProps {
  activeCountrySteam?: string;
}
const _exp4 = /*#__PURE__*/() => Icon;
const _exp5 = /*#__PURE__*/() => ({
  activeCountrySteam,
  theme
}: ThemeProps & StyleIconProps) => activeCountrySteam === 'Страны СНГ' ? 'rgba(250, 250, 250, 0.6)' : theme.colors.icon.tertiary;
const StyledIcon = withTheme(/*#__PURE__*/styled(_exp4())({
  name: "StyledIcon",
  class: "shehjcg",
  propsAsIs: true,
  vars: {
    "shehjcg-0": [_exp5()]
  }
}));
interface InnerWrapperProps {
  asWrapper: boolean;
  isActive: boolean;
}
const _exp6 = /*#__PURE__*/() => ({
  theme,
  isActive
}: ThemeProps & InnerWrapperProps) => isActive ? theme.colors.icon.white : theme.colors.icon.primary;
const InnerWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "InnerWrapper",
  class: "i19umj79",
  propsAsIs: false,
  vars: {
    "i19umj79-0": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => Text;
const _exp8 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.colors.text.primary;
const HintTextWrapper = withTheme(/*#__PURE__*/styled(_exp7())({
  name: "HintTextWrapper",
  class: "h565d73",
  propsAsIs: true,
  vars: {
    "h565d73-0": [_exp8()]
  }
}));
const _exp9 = /*#__PURE__*/() => Tippy;
const StyledTippy = /*#__PURE__*/styled(_exp9())({
  name: "StyledTippy",
  class: "s5864gp",
  propsAsIs: true
});

require("./ToolTipText.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ToolTipText.tsx");